import { RingConfiguration } from '@ringo/types'

import {
    AlloyControllerApi as GeneratedAlloyControllerApi,
    MetalPriceControllerApi as GeneratedMetalPriceControllerApi,
    IamControllerApi as GeneratedIamControllerApi,
    MasterDataControllerApi as GeneratedMasterDataControllerApi,
    AddressControllerApi as GeneratedAddressControllerApi,
    UserControllerApi as GeneratedUserControllerApi,
    FileControllerApi as GeneratedFileControllerApi,
    MetalAccountControllerApi as GeneratedMetalAccountControllerApi,
    ShippingDateControllerApi as GeneratedShippingDateControllerApi,
    ShoppingCartItemDTO as GeneratedShoppingCartItemDTO,
    InfoControllerApi as GeneratedInfoControllerApi,
    SettingsControllerApi as GeneratedSettingsControllerApi,
    PublicImageControllerApi as GeneratedPublicImageControllerApi,
    PublicNewsletterControllerApi as GeneratedPublicNewsletterControllerApi,
    UserCouponControllerApi as GeneratedUserCouponControllerApi,
    Configuration,
    CalculationControllerApi as GeneratedCalculationControllerApi,
    FavoriteControllerApi as GeneratedFavoriteControllerApi,
    ShoppingCartControllerApi as GeneratedShoppingCartControllerApi,
    OrderCustomerControllerApi as GeneratedOrderCustomerControllerApi,
} from '@ringo/shared'

export class MetalPriceControllerApiControllerApi extends GeneratedMetalPriceControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}

export class UserControllerApi extends GeneratedUserControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}

export class AlloyControllerApi extends GeneratedAlloyControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}

export class IamControllerApi extends GeneratedIamControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}

export class MasterDataControllerApi extends GeneratedMasterDataControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}

export class AddressControllerApi extends GeneratedAddressControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}

export class UserCouponControllerApi extends GeneratedUserCouponControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}

export class FileControllerApi extends GeneratedFileControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}

export class MetalAccountControllerApi extends GeneratedMetalAccountControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}

export class InfoControllerApi extends GeneratedInfoControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}

export class SettingsControllerApi extends GeneratedSettingsControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}

export class PublicImageControllerApi extends GeneratedPublicImageControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}

export class CalculationControllerApi extends GeneratedCalculationControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}

export class FavoriteControllerApi extends GeneratedFavoriteControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}

export class OrderControllerApi extends GeneratedOrderCustomerControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}

export class ShoppingCartControllerApi extends GeneratedShoppingCartControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}

export type ShoppingCartItemDTO = {
    [Property in keyof GeneratedShoppingCartItemDTO | 'ringConfigurations']: Property extends 'ringConfigurations'
        ? RingConfiguration[]
        : Property extends keyof GeneratedShoppingCartItemDTO
          ? GeneratedShoppingCartItemDTO[Property]
          : never
}
export class ShippingDateControllerApi extends GeneratedShippingDateControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }

    public async getFormatedShippingDates(): Promise<string[]> {
        const response = (await super.getShippingDates()).data

        function formatDate(dateArray: string) {
            const year = dateArray[0]
            const month = String(dateArray[1]).padStart(2, '0')
            const day = String(dateArray[2]).padStart(2, '0')
            return `${year}-${month}-${day}`
        }

        const selectableShippingDates = response?.filter((item) => item.selectable)

        const formattedShippingDates = selectableShippingDates?.map((item) => formatDate(item.date as string))

        return formattedShippingDates
    }
}

export class PublicNewsletterControllerApi extends GeneratedPublicNewsletterControllerApi {
    constructor(configuration: Configuration) {
        super(configuration)
    }
}
